import axiosInstance from '../../lib/api/axios';
import { BFF_URL } from '../../lib/config';
import { Service } from './types';

export const getCurrentAppServices = async (activeAppId: number): Promise<Service[]> => {
  const { data } = await axiosInstance.get(`${BFF_URL}/apps/${activeAppId}/services`);
  return data;
};
